module.exports = __webpack_public_path__ + "assets/img/w_d_i_12.5ea9ad2b.jpg";